export default __webpack_public_path__ + "static/media/Repressor's Flamebrand.a4110091.jpg";